import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "8",
  viewBox: "0 0 16 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "fill",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.1716 0.462853L15.3536 3.64483C15.5488 3.8401 15.5488 4.15668 15.3536 4.35194L12.1716 7.53392C11.9763 7.72918 11.6597 7.72918 11.4645 7.53392C11.2692 7.33866 11.2692 7.02208 11.4645 6.82681L13.7929 4.49839H0V3.49839H13.7929L11.4645 1.16996C11.2692 0.974698 11.2692 0.658115 11.4645 0.462853C11.6597 0.267591 11.9763 0.267591 12.1716 0.462853Z",
      fill: "#A0A0A0"
    }, null, -1)
  ])))
}
export default { render: render }